/** Joins class names, dropping the falsy ones. The kit's only styling helper. */
export const cx = (...parts: (string | false | null | undefined)[]): string =>
  parts.filter(Boolean).join(" ");
